const SALES_REGIONS_AND_FUNCTIONS_UNSORTED = [
    "Canada Sales",
    "Commerical Sales",
    "Corporate Office",
    "FSS Team",
    "Government Contracts NEGC",
    "Govt Sales- North",
    "Govt Sales- South",
    "Govt Sales- West",
    "Govt Function VP Admin & Ops",
    "Healthcare - West",
    "Healthcare - East",
    "Healthcare Corp. Sales Team",
    "Inside Sales",
    "Manufacturing Sales",
    "National Accounts",
    "Other",
    "Puerto Rico",
    "External - Channel/Small Business",
    "Healthcare Function VP Admin & Ops"
] as const;

export const SALES_REGIONS_AND_FUNCTIONS = Array.from(SALES_REGIONS_AND_FUNCTIONS_UNSORTED).sort((a, b) =>
    a.localeCompare(b)
);
